/**
 * Page Enquire View
 */
class PageEnquireView {

	constructor(presenter, sectionId) {

		this.parent = $("#shopify-section-" + sectionId);
		this.form = $("#mon-form-enquire");
		this.inputContactPreference = $("#mon-form-enquire-input-contact-preference");
		this.submit = $("#mon-form-enquire-submit");
		this.presenter = presenter;

		/*
		 * Listeners
		 */

		this.submit.on("click", $.proxy(function(_event) {
			
			// validate the form
			const result = this.validateForm();
			if (result === true) {
				
				// the form is okay, so get and set all the checked contact preferences
				const checked = this.form.find("input[type='checkbox']:checked").map(function() {
					return $(this).val();
				}).get();
				if (checked.length > 0) {
					this.inputContactPreference.val(checked.join(", "));
				}
				
				// submit the form
				this.form.submit();

			}

		}, this));

	}

	/*
	 * Actions
	 */

	validateForm() {

		// check whether this form is valid
		const result = this.form.get(0).checkValidity();
		if (result === false) {

			// for any validation feedback elements, show their error message
			this.form.find(".form-control:invalid").each(function() {
				const feedback = $(this).parent().next("div.invalid-feedback");
				feedback.removeClass("d-none").addClass("d-block");
			});

		}

        // for any validation feedback elements that do not have an error, clear the error message
		this.form.find(".form-control:valid").each(function() {
			const feedback = $(this).parent().next("div.invalid-feedback");
			feedback.removeClass("d-block").addClass("d-none");
		});

		return result;

	}

	/*
	 * Getters and Setters
	 */

}